<div class="col full-height layout-row"
     [ngClass]="{'selected': isSelected, 'locked': route.isBlockedByUser}"
     (mouseenter)="onHover(true)"
     (mouseleave)="onHover(false)"
     (dblclick)="onDrillDownDblClick($event)">

  <!--  <div *ngIf="item.handle"-->
  <!--    class="drag-handle align-self-center mx-3 my-0"-->
  <!--    dndHandle-->
  <!--    matListItemIcon>-->
  <!--    <bringoz-icon icon-name="account"></bringoz-icon>-->
  <!--  </div>-->

  <div class="flex-5 layout-column layout-align-center-center gap-5">
    <ng-container>
      <ng-container *ngTemplateOutlet="dragHandleTemplate"></ng-container>
    </ng-container>

    <bringoz-button *ngIf="route.isBlockedByUser || (canLock && isHover)"
                    type="tertiary"
                    size="fit"
                    (onClick)="onToggleLocked();$event.stopPropagation();">
      <bringoz-icon [iconName]="route.isBlockedByUser ? 'lock' : 'lock-outline'" classSize="lg"
                    fill="#484848"></bringoz-icon>
    </bringoz-button>
    <div class="index-border" [style.background-color]="route.color"></div>
    <bringoz-button *ngIf="isVisible || (canShow && isHover)"
                    type="tertiary"
                    size="fit"
                    (onClick)="onToggleVisible.emit({route: route, isVisible: isVisible});$event.stopPropagation();">
      <bringoz-icon iconName="eye" classSize="lg" [fill]="isVisible ? '#266AFF' : '#484848'"></bringoz-icon>
    </bringoz-button>
  </div>

  <div class="flex layout-column padding-left-5">

    <!--Link Row-->
    <div class="layout-row layout-align-start-center route-title full-width gap-5">
      <app-bringoz-checkbox *ngIf="canSelect"
                            [isChecked]="excludeMode ? !isSelected : isSelected"
                            [isDisabled]="isDisabled"
                            (clickEvent)="onToggle.emit(!isSelected)"
                            (click)="$event.stopPropagation()"
                            (dblclick)="$event.stopPropagation()">
      </app-bringoz-checkbox>

      <app-bringoz-status-tag [status]="route.status" isSmall="true"></app-bringoz-status-tag>

      <div class="flex gap-5 layout-row">
        <div class="flex layout-row clickable gap-5"
             (click)="onChangeRouteResource.emit({route: route, event: $event});$event.stopPropagation();">
          <div class="flex layout-row br-body-1 gap-5"
               [ngbTooltip]="route?.name ? route?.name : (route?.resource?.allocationName || route?.resource?.vehicleName || route?.planningResource?.name)"
               openDelay="300"
               triggers="hover"
               placement="top-start"
               container="body">
            <span class="text-ellipsis">{{ route?.name ? route?.name : 'Route' | translate }} {{ route?.resource?.allocationName || route?.resource?.vehicleName || route?.planningResource?.name }}</span>
            <span id="route-resource-arrow">▾</span>
          </div>
<!--          <span id="route-resource-arrow">▾</span>-->
        </div>
        <div>{{route.id}}</div>
        <div *ngIf="settings?.columns?.services" class="layout-row layout-align-start-center gap-2">
          <span *ngIf="route.serviceIdList?.length" class="br-body-1">{{route.serviceIdList.length === 1 ? ('X_SERVICE' | translate: {sum: route.serviceIdList.length}) : ('X_SERVICES' | translate: {sum: route.serviceIdList.length}) }}</span>
        </div>
      </div>

      <bringoz-button *ngIf="canClose"
                      type="tertiary"
                      [ngbTooltip]="'Back'"
                      (onClick)="onClose.emit()">
        <bringoz-icon iconName="arrow-left" classSize="lg" fill="#484848"></bringoz-icon>
      </bringoz-button>

    </div>

    <div class="flex layout-row full-width route-body layout-wrap"
         [ngClass]="{'disable': !canDrilldown}"
         (click)="onClick($event)">

      <!--ID-->
      <div *ngIf="settings?.columns?.id" class="flex-100 layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="hash"
                      classSize="sm"
                      [ngbTooltip]="'ROUTES_VIEW_ROUTES_SETTINGS.id' | translate"
                      openDelay="300">

        </bringoz-icon>
        <div class="flex layout-row"
             (mouseenter)="isShowCopyBtn=true"
             (mouseleave)="isShowCopyBtn=false"
             (dblclick)="$event.stopPropagation()">
          <app-bringoz-state-link class="text-ellipsis"
                                  [state]="'planning-route'"
                                  [params]="{id: route.id}"
                                  [permission]="'routes.list'"
                                  [text]="route.id">
          </app-bringoz-state-link>
          <app-text-copy-button [isShowCopyBtn]="isShowCopyBtn"
                                [text]="route.id">

          </app-text-copy-button>
        </div>
      </div>

      <!--Time Window Row-->
      <div *ngIf="settings?.columns?.timeWindow" class="flex-100 layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="time-window-outline"
                      classSize="sm"
                      [ngbTooltip]="'ROUTES_VIEW_ROUTES_SETTINGS.timeWindow' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ route | timeWindow }}</span>
      </div>

      <!--Duration Row-->
      <div *ngIf="settings?.columns?.duration" class="flex-50 layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="timer-outline"
                      classSize="sm"
                      [ngbTooltip]="'ROUTES_VIEW_ROUTES_SETTINGS.duration' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ route.totalTimeSec | bringozTimeConvert }}</span>
      </div>

      <!--Picking Hour-->
      <div *ngIf="settings?.columns?.pickingHour" class="flex-50 layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="depot"
                      classSize="sm"
                      [ngbTooltip]="'ROUTES_VIEW_ROUTES_SETTINGS.pickingHour' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{pickingTime | bringozTime:'time' }}</span>
      </div>

      <!--Trip Number Row-->
      <div *ngIf="settings?.columns?.trips" class="flex-50 layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="route"
                      classSize="sm"
                      [ngbTooltip]="'ROUTES_VIEW_ROUTES_SETTINGS.trips' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ route.sequenceInRouteGroup || '--' }}</span>
      </div>

      <!--Accounts Row-->
      <div *ngIf="settings?.columns?.accounts" class="flex-50 layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="account"
                      classSize="sm"
                      [ngbTooltip]="'ROUTES_VIEW_ROUTES_SETTINGS.accounts' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis"
              [ngbTooltip]="accountsTooltip"
              tooltipClass="routes-panel-list-item-accounts-tooltip"
              openDelay="300" triggers="hover" container="body">
          {{route.accountIds.length === 1 ? ('X_ACCOUNT' | translate: {length: route.accountIds.length}) : ('X_ACCOUNTS' | translate: {length: route.accountIds.length}) }}
        </span>

        <ng-template #accountsTooltip>
          <div class="col" style="min-width: 450px;">
            <div class="flex layout-row">
              <div class="flex br-caption-1" style="text-align: start;">{{'Account Name' | translate}}:</div>
              <div class="flex br-caption-1" style="text-align: start;">{{'Address' | translate}}:</div>
              <div class="flex br-caption-1" style="text-align: start;">{{'Account External ID' | translate}}:</div>
              <div class="flex-15 br-caption-1" style="text-align: start;">{{'Pallets' | translate}}:</div>
            </div>

            <div class="flex layout-row" *ngFor="let reference of accountReferences">
              <div class="flex" style="text-align: start;">
                {{reference.name}}
              </div>

              <div class="flex layout-align-center-center text-ellipsis" style="text-align: start;">
                {{ reference.address ? (reference.address | bringozAddressCity) : '---'}}
              </div>

              <div class="flex layout-align-center-center text-ellipsis" style="text-align: start;">
                {{reference.externalId || '---' }}
              </div>

              <div class="flex-15 layout-row layout-align-start-center gap-5">
                {{reference.pallets | number: '1.0-2'}}
                <bringoz-icon iconName="pallets" classSize="sm"></bringoz-icon>
              </div>
            </div>
          </div>
        </ng-template>
      </div>

      <!--Accounts Row-->
      <div *ngIf="settings?.columns?.accountsExternalIds" class="flex-100 layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="hash"
                      classSize="sm"
                      [ngbTooltip]="'ROUTES_VIEW_ROUTES_SETTINGS.accountsExternalIds' | translate"
                      openDelay="300">

        </bringoz-icon>
        <app-bringoz-items-list-display *ngIf="route.accountReferences?.length" class="flex"
                                        [itemsList]="{list: route?.accountReferences, displayKey: 'externalId'}"
                                        [maxItems]="6">
        </app-bringoz-items-list-display>
        <span *ngIf="!route.accountReferences?.length">---</span>
      </div>

      <!--Agent Row-->
      <div *ngIf="settings?.columns?.agent" class="flex-50 layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="agent"
                      classSize="sm"
                      [ngbTooltip]="'ROUTES_VIEW_ROUTES_SETTINGS.agent' | translate"
                      openDelay="300">

        </bringoz-icon>
        <app-agent-itinerary-link class="text-ellipsis"
                                  [linkToAgentView]="true"
                                  [agent]="route.agentReference"
                                  [isShowCopyButton]="true">
        </app-agent-itinerary-link>
        <bringoz-icon *ngIf="route.status === 'Unassigned' && route.agentReference"
                      iconName="assistant"
                      classSize="sm"
                      [ngbTooltip]="'ROUTES_VIEW_ROUTES_SETTINGS.associatedAgentDescription' | translate"
                      openDelay="300">

        </bringoz-icon>
      </div>

      <!-- Assistants -->
      <div *ngIf="settings?.columns?.assistant" class="flex-50 layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon [iconName]="'assistant'"
                      [classSize]="'sm'"
                      [ngbTooltip]="'ROUTES_VIEW_ROUTES_SETTINGS.assistant' | translate">
        </bringoz-icon>
        <app-bringoz-items-link-list *ngIf="route.assistantAgentReferences"
                                     style="max-width: 80%;"
                                     [textEllipsis]="true"
                                     [state]="'agent.agent-profile'"
                                     [items]="route.assistantAgentReferences"
                                     [maxDisplay]="1"
                                     [permission]="'drivers.get'">
        </app-bringoz-items-link-list>
        <span *ngIf="!route.assistantAgentReferences">---</span>
      </div>

      <!--Skills Row-->
      <div *ngIf="settings?.columns?.skills" class="flex-50 layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="tag-outline"
                      classSize="sm"
                      [ngbTooltip]="'ROUTES_VIEW_ROUTES_SETTINGS.skills' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span *ngIf="!route.requiredSkills.length" class="br-body-1 text-ellipsis">---</span>
        <app-skill-tags class="flex" [skillsIds]="route.requiredSkills" [limit]="1"></app-skill-tags>
      </div>

      <!--Tags Row -->
      <div *ngIf="settings?.columns?.tags"
           class="flex-50 layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="label-outline"
                      classSize="sm"
                      [ngbTooltip]="'ROUTES_VIEW_ROUTES_SETTINGS.tags' | translate"
                      openDelay="300">

        </bringoz-icon>
        <app-bringoz-tags *ngIf="route.planningResource?.tags?.length"
                          class="flex"
                          [tags]="route.planningResource.tags"
                          [maxTags]="1"
                          [isShowTagDescriptions]="true">
        </app-bringoz-tags>
      </div>

      <!--Resource Row-->
      <div *ngIf="settings?.columns?.resource" class="flex-50 layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon [iconName]="route.vehicleType?.toLowerCase() || 'truck'"
                      [classSize]="'sm'"
                      [ngbTooltip]="'ROUTES_VIEW_ROUTES_SETTINGS.resource' | translate"
                      openDelay="300">

        </bringoz-icon>

        <div class="flex layout-row text-ellipsis gap-5">
          <!--      <app-bringoz-state-link *ngIf="route.agentReference"-->
          <!--                              class="text-ellipsis"-->
          <!--                              [ngbTooltip]="route.agentReference | userName"-->
          <!--                              openDelay="300" triggers="hover"-->
          <!--                              [state]="'agent.agent-profile'"-->
          <!--                              [permission]="'drivers.get'"-->
          <!--                              [params]="{id: route.agentReference.id}"-->
          <!--                              [text]="route.agentReference | userName">-->
          <!--      </app-bringoz-state-link>-->

          <app-bringoz-state-link *ngIf="route.planningResource?.mainLogisticsVehicleReference"
                                  class="text-ellipsis"
                                  [state]="'logistics-vehicle.vehicle-profile'"
                                  [ngbTooltip]="route.planningResource.mainLogisticsVehicleReference.name"
                                  openDelay="300" triggers="hover"
                                  [params]="{id: route.planningResource.mainLogisticsVehicleReference.id}"
                                  [text]="route.planningResource.mainLogisticsVehicleReference.name">
          </app-bringoz-state-link>

          <app-bringoz-state-link *ngIf="route.planningResource?.attachedLogisticsVehicleReferences?.length"
                                  class="text-ellipsis"
                                  [state]="'logistics-vehicle.vehicle-profile'"
                                  [ngbTooltip]="route.planningResource.attachedLogisticsVehicleReferences[0].name"
                                  openDelay="300" triggers="hover"
                                  [params]="{id: route.planningResource.attachedLogisticsVehicleReferences[0].id}"
                                  [text]="route.planningResource.attachedLogisticsVehicleReferences[0].name">
          </app-bringoz-state-link>
        </div>

      </div>

      <!--Plate Number-->
      <div *ngIf="settings?.columns?.plateNumber" class="flex-50 layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="plate-number"
                      [classSize]="'sm'"
                      [ngbTooltip]="'ROUTES_VIEW_ROUTES_SETTINGS.plateNumber' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span *ngIf="!route.planningResource?.mainLogisticsVehicleReference?.licensePlateNumber">---</span>
        <span class="br-body-1 text-ellipsis"
              *ngIf="!!route.planningResource?.mainLogisticsVehicleReference?.licensePlateNumber"
              [ngbTooltip]="route.planningResource.mainLogisticsVehicleReference.licensePlateNumber"
              openDelay="300" triggers="hover">
        {{ route.planningResource.mainLogisticsVehicleReference.licensePlateNumber }}
      </span>
      </div>

      <!--Tasks Count-->
      <div *ngIf="settings?.columns?.tasksCount" class="flex-50 layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="location-pin-outline"
                      [classSize]="'sm'"
                      [ngbTooltip]="'ROUTES_VIEW_ROUTES_SETTINGS.tasksCount' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span *ngIf="route.taskIdListExt?.length" class="br-body-1">{{route.taskIdListExt.length === 1 ? ('X_TASK' | translate: {sum: route.taskIdListExt.length}) : ('X_TASKS' | translate: {sum: route.taskIdListExt.length}) }}</span>
      </div>

      <!--Pickup Stops-->
      <div *ngIf="settings?.columns?.pickupStops" class="flex-50 layout-row layout-align-start-center info-row gap-5">
        <app-task-purpose [ngbTooltip]="'ROUTES_VIEW_ROUTES_SETTINGS.pickupStops' | translate"
                          openDelay="300"
                          purpose="Pickup"
                          [firstLetterOnly]="true">

        </app-task-purpose>
        <span *ngIf="stopsCount" class="br-body-1">{{stopsCount.pickup === 1 ? ('X_STOP' | translate: {sum: stopsCount.pickup}) : ('X_STOPS' | translate: {sum: stopsCount.pickup}) }}</span>
      </div>

      <!--Destination Stops-->
      <div *ngIf="settings?.columns?.destinationStops" class="flex-50 layout-row layout-align-start-center info-row gap-5">
        <app-task-purpose [ngbTooltip]="'ROUTES_VIEW_ROUTES_SETTINGS.destinationStops' | translate"
                          openDelay="300"
                          purpose="Dropoff"
                          [firstLetterOnly]="true">

        </app-task-purpose>
        <span *ngIf="stopsCount" class="br-body-1">{{stopsCount.destination === 1 ? ('X_STOP' | translate: {sum: stopsCount.destination}) : ('X_STOPS' | translate: {sum: stopsCount.destination}) }}</span>
      </div>

      <!-- Pro Number Row -->
      <div *ngIf="settings?.columns?.proNumber"
           class="flex-50 layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="hash"
                      classSize="md"
                      fill="#484848"
                      [ngbTooltip]="'PRO Number' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span *ngIf="proNumbers.length === 0">---</span>
        <app-bringoz-items-list-display *ngIf="proNumbers.length > 0"
                                        [items]="proNumbers"
                                        [maxItems]="1"
                                        [isTransparentBackground]="true"
                                        [canCopy]="true">
        </app-bringoz-items-list-display>
      </div>

      <!-- Relations Row -->
      <div *ngIf="settings?.columns?.relations"
           class="flex-50 layout-row layout-align-start-center info-row gap-5">
        <app-task-relations-indicator [relations]="relations" (onClick)="onRelationsClick($event)">
        </app-task-relations-indicator>
      </div>

      <!-- Reference IDs Row -->
      <div *ngIf="settings?.columns?.referenceIds"
           class="flex-50 layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="hash"
                      classSize="md"
                      fill="#484848"
                      [ngbTooltip]="'Reference IDs' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span *ngIf="!route.referenceIds?.length">---</span>
        <app-bringoz-items-list-display *ngIf="!!route.referenceIds?.length"
                                        [items]="route.referenceIds"
                                        [maxItems]="2"
                                        [isTransparentBackground]="true">
        </app-bringoz-items-list-display>
      </div>

      <!--Distance Row-->
      <div *ngIf="settings?.columns?.distance" class="flex-50 layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="distance"
                      [classSize]="'sm'"
                      [ngbTooltip]="'ROUTES_VIEW_ROUTES_SETTINGS.distance' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ route.totalDistanceMeter | bringozDistance:'---':true }}</span>
      </div>

      <!--Load - Weight-->
      <div *ngIf="settings?.load?.weight"
           class="flex-50 layout-row layout-align-start-center info-row gap-5 text-ellipsis">
        <bringoz-icon iconName="weight"
                      classSize="sm"
                      [ngbTooltip]="'LOAD_SETTINGS.weight' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ route.totals.totalLoad | bringozWeight:true:'---':false:2 }}</span>
      </div>

      <!--Load - Volume-->
      <div *ngIf="settings?.load?.volume"
           class="flex-50 layout-row layout-align-start-center info-row gap-5 text-ellipsis">
        <bringoz-icon iconName="volume"
                      classSize="sm"
                      [ngbTooltip]="'LOAD_SETTINGS.volume' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ route.totals.totalVolume | bringozVolume: true:'---' }}</span>
      </div>

      <!--Load - Packages-->
      <div *ngIf="settings?.load?.packages"
           class="flex-50 layout-row layout-align-start-center info-row gap-5 text-ellipsis">
        <bringoz-icon iconName="package-outline"
                      classSize="sm"
                      [ngbTooltip]="'LOAD_SETTINGS.packages' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span *ngIf="route.totalLoad?.numberOfPackages > 0; else emptyLoad"
              class="br-body-1 text-ellipsis">{{ (route.totalLoad.numberOfPackages === 1 ? 'X_PACKAGE' : 'X_PACKAGES') | translate:{ sum: route.totalLoad.numberOfPackages } }}</span>
      </div>

      <!--Load - Pallets-->
      <div *ngIf="settings?.load?.pallets"
           class="flex-50 layout-row layout-align-start-center info-row gap-5 text-ellipsis">
        <bringoz-icon iconName="pallets"
                      classSize="sm"
                      [ngbTooltip]="'LOAD_SETTINGS.pallets' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span *ngIf="route.totalLoad.numberOfPallets > 0; else emptyLoad"
              class="br-body-1 text-ellipsis">{{ (route.totalLoad.numberOfPallets === 1 ? 'X_PALLET' : 'X_PALLETS') | translate:{sum: (route.totalLoad.numberOfPallets | number: '1.0-2') ?? 0} }}</span>
      </div>

      <!--Load - Spots-->
      <div *ngIf="settings?.load?.spots"
           class="flex-50 layout-row layout-align-start-center info-row gap-5 text-ellipsis">
        <bringoz-icon iconName="spot"
                      classSize="sm"
                      [ngbTooltip]="'LOAD_SETTINGS.spots' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span
          class="br-body-1 text-ellipsis">{{ (route.totals.totalSpots === 1 ? 'X_SPOT' : 'X_SPOTS') | translate:{sum: route.totals.totalSpots ?? 0} }}</span>
      </div>

      <!--Price-->
      <div *ngIf="settings?.columns?.price" class="flex-50 layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="dollar-circle"
                      classSize="sm"
                      [ngbTooltip]="'ROUTES_VIEW_ROUTES_SETTINGS.price' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ route.courierPrice | bringozPrice: '---' }}</span>
      </div>

      <!--Value-->
      <div *ngIf="settings?.columns?.value" class="flex-50 layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="dollar-circle"
                      classSize="sm"
                      [ngbTooltip]="'Value' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ route.totalPrice | bringozPrice: '---' }}</span>
      </div>

      <!--Load - Value-->
      <div *ngIf="settings?.load?.value"
           class="flex-50 layout-row layout-align-start-center info-row gap-5 text-ellipsis">
        <bringoz-icon iconName="dollar-circle"
                      classSize="sm"
                      [ngbTooltip]="'LOAD_SETTINGS.value' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ route.totals?.value | bringozPrice: '---' }}</span>
      </div>

      <!--Weight Capacity Row-->
      <div *ngIf="(settings.capacity?.weight)"
           class="flex-50 layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="weight"
                      classSize="sm"
                      fill="#484848"
                      [ngbTooltip]="'Weight' | translate"
                      openDelay="300">
        </bringoz-icon>
        <app-bringoz-capacity-bar *ngIf="route.maxLoad.weight; else unlimitedWeight"
                                  [value]="(route.totals.totalLoad / route.maxLoad.weight) * 100"
                                  [unit]="'%'"
                                  [severityThresholds]="severityThresholds"
                                  [showValue]="true"
                                  [ngbTooltip]="{ current: route.totals.totalLoad, max: route.maxLoad.weight } | capacityTooltipPipe:weightUnit"
                                  [tooltipClass]="weightSeverity">
        </app-bringoz-capacity-bar>

        <ng-template #unlimitedWeight>
          <div [ngbTooltip]="{ current: route.totals.totalLoad, max: route.maxLoad.weight } | capacityTooltipPipe:weightUnit" class="flex layout-row layout-align-start-center gap-5">
            <div class="unlimited-container layout-row layout-align-center-center">
              <span class="br-caption-1 font-weight-500">{{'UNLIMITED' | translate}}</span>
            </div>
            <bringoz-icon iconName="infinite"></bringoz-icon>
          </div>
        </ng-template>
      </div>

      <!--Volume Capacity Row-->
      <div
        *ngIf="(settings.capacity?.volume)"
        class="flex-50 layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="volume"
                      classSize="sm"
                      fill="#484848"
                      [ngbTooltip]="'Volume' | translate"
                      openDelay="300">
        </bringoz-icon>
        <app-bringoz-capacity-bar *ngIf="volumeCapacity; else unlimitedVolume"
                                  [value]="(route.totals.totalVolume / volumeCapacity) * 100"
                                  [unit]="'%'"
                                  [severityThresholds]="severityThresholds"
                                  [showValue]="true"
                                  [ngbTooltip]="{ current: route.totals.totalVolume, max: volumeCapacity } | capacityTooltipPipe:volumeUnit"
                                  [tooltipClass]="volumeSeverity">
        </app-bringoz-capacity-bar>

        <ng-template #unlimitedVolume>
          <div [ngbTooltip]="{ current: route.totals.totalVolume, max: volumeCapacity } | capacityTooltipPipe:volumeUnit" class="flex layout-row layout-align-start-center gap-5">
            <div class="unlimited-container layout-row layout-align-center-center">
              <span class="br-caption-1 font-weight-500">{{'UNLIMITED' | translate}}</span>
            </div>
            <bringoz-icon iconName="infinite"></bringoz-icon>
          </div>
        </ng-template>
      </div>

      <!--Pallets Capacity Row-->
      <div
        *ngIf="(settings.capacity?.pallets)"
        class="flex-50 layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="pallets"
                      classSize="sm"
                      fill="#484848"
                      [ngbTooltip]="'Pallets' | translate"
                      openDelay="300">
        </bringoz-icon>
        <app-bringoz-capacity-bar *ngIf="route.maxLoad.numberOfPallets; else unlimitedPallets"
                                  [value]="(route.totals.totalPallets / route.maxLoad.numberOfPallets) * 100"
                                  [unit]="'%'"
                                  [severityThresholds]="severityThresholds"
                                  [showValue]="true"
                                  [ngbTooltip]="{ current: route.totals.totalPallets, max: route.maxLoad.numberOfPallets } | capacityTooltipPipe"
                                  [tooltipClass]="palletsSeverity">
        </app-bringoz-capacity-bar>

        <ng-template #unlimitedPallets>
          <div [ngbTooltip]="{ current: route.totals.totalPallets, max: route.maxLoad.numberOfPallets } | capacityTooltipPipe" class="flex layout-row layout-align-start-center gap-5">
            <div class="unlimited-container layout-row layout-align-center-center">
              <span class="br-caption-1 font-weight-500">{{'UNLIMITED' | translate}}</span>
            </div>
            <bringoz-icon iconName="infinite"></bringoz-icon>
          </div>
        </ng-template>
      </div>

      <!--Progress Row-->
      <div *ngIf="settings?.columns?.progress" class="flex-50 layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="point-to-point"
                      classSize="sm"
                      fill="#484848"
                      [ngbTooltip]="'ROUTES_VIEW_ROUTES_SETTINGS.progress' | translate"
                      openDelay="300">

        </bringoz-icon>
        <app-bringoz-capacity-bar class="flex"
                                  [value]="(route.stats?.finished * 100) / route.stats?.total"
                                  [unit]="'%'"
                                  [showValue]="true"
                                  [isDisableSeverity]="true">
        </app-bringoz-capacity-bar>
      </div>

      <!--Metadata Rows-->
      <div *ngFor="let metaData of enabledMetadata" class="flex-50 layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="meta-data"
                      [classSize]="'sm'"
                      [ngbTooltip]="metaData.title"
                      openDelay="300">
        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">
        {{ route.metaData | bringozMetaDataDisplay: metaData }}
      </span>
      </div>


    </div>

  </div>

  <div *ngIf="(isHover) && !canClose"
       class="drill-down-arrow full-height-arrow"
       (click)="onDrillDownClick($event)">
    <bringoz-icon iconName="arrow-right" classSize="lg" fill="#484848"></bringoz-icon>
  </div>

</div>

<ng-template #dragHandleTemplate>
  <div class="drag-wrapper">
    <ng-content></ng-content>
  </div>
</ng-template>

<ng-template #emptyLoad>
  <span class="br-body-1">---</span>
</ng-template>
